// Display labels shared by the Training page components.
import type { PersonaKind } from '../../../src/shared/api';

export const KIND_LABEL: Record<PersonaKind, string> = { gatekeeper: 'Gatekeeper', lukewarm: 'Lukewarm owner', hostile: 'Hostile owner' };
